import React from "react";
import { useDispatch } from "react-redux";
// import { fetchHeatData, fetchHeatDetails } from "redux/slices/heatSlice";
import {
  fetchHeatData,
  fetchHeatDetails,
} from "features/deviceConfig/deviceConfigThunk";
import { setDeviceData } from "features/deviceConfig/deviceConfigSlice";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";

function FilterSection() {
  const [searchTerm, setSearchTerm] = React.useState("");
  const dispatch = useDispatch();

  const handleSearchKeyPress = () => {
    dispatch(fetchHeatData(searchTerm));
    dispatch(fetchHeatDetails(searchTerm));
    setInterval(() => {
      if (searchTerm.trim() !== "") {
        dispatch(fetchHeatData(searchTerm));
        dispatch(fetchHeatDetails(searchTerm));
      }
    }, 4000);
    dispatch(setDeviceData(true));
  };

  return (
    <MDBox display="flex" alignItems="center">
      <MDInput
        label="Search"
        variant="outlined"
        fullWidth
        borderRadius="0px !important"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        right="1rem"
        p={1.2}
        pb={1.3}
        sx={{ cursor: "pointer", background: "#2e83e6ff" }}
        borderRadius="0px 8px 8px 0px"
        onClick={handleSearchKeyPress}
      >
        <Icon fontSize="medium" sx={{ color: "#fff" }}>
          search
        </Icon>
      </MDBox>
    </MDBox>
  );
}

export default FilterSection;
